import React, { useState } from 'react';
import axios from 'axios';
import Mark from 'mark.js';
import API_BASE_URL from '../config';  // Adjust if config file is in another location

const RiskDetector = () => {
  const [documentText, setDocumentText] = useState('');
  const [file, setFile] = useState(null);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!documentText && !file) {
      alert("Please upload a file or paste some text.");
      return;
    }

    const formData = new FormData();
    if (file) {
      formData.append('file', file);
    }
    formData.append('text', documentText);

    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}/detect-risk`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      setResults(response.data.detected_risks);
      setDocumentText(response.data.document_text);
      highlightPhrases(response.data.detected_risks);
    } catch (error) {
      console.error("Error detecting risks:", error);
      alert("An error occurred while processing the document.");
    } finally {
      setLoading(false);
    }
  };

  const highlightPhrases = (phrases) => {
    setTimeout(() => {
      const context = document.querySelector("#documentDisplay");
      if (context) {
        const instance = new Mark(context);
        instance.unmark({
          done: () => {
            instance.mark(phrases.map((p) => p.phrase));
          },
        });
      }
    }, 100);  // Slight delay to ensure DOM is ready
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-2">Upload Document or Paste Text</h2>
      
      <textarea
        rows="6"
        className="w-full border p-2"
        placeholder="Paste your document text here..."
        value={documentText}
        onChange={(e) => setDocumentText(e.target.value)}
      ></textarea>

      <div className="mt-2">
        <input
          type="file"
          accept=".pdf,.docx,.txt"
          onChange={(e) => setFile(e.target.files[0])}
        />
      </div>

      <button
        onClick={handleSubmit}
        className="bg-blue-600 text-white p-2 mt-3 rounded hover:bg-blue-700"
        disabled={loading}
      >
        {loading ? "Processing..." : "Detect Risks"}
      </button>

      <div
        id="documentDisplay"
        className="mt-6 border p-4 whitespace-pre-wrap"
        style={{ minHeight: '200px' }}
      >
        {documentText}
      </div>

      {results.length > 0 && (
        <div className="mt-6">
          <h3 className="text-lg font-semibold">Detected Risks:</h3>
          <table className="w-full mt-2 border">
            <thead>
              <tr>
                <th className="border p-2">Phrase</th>
                <th className="border p-2">Type</th>
                <th className="border p-2">Score</th>
              </tr>
            </thead>
            <tbody>
              {results.map((risk, index) => (
                <tr key={index}>
                  <td className="border p-2">{risk.phrase}</td>
                  <td className="border p-2">{risk.type}</td>
                  <td className="border p-2">{risk.score ? risk.score.toFixed(2) : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RiskDetector;